import { createSelector } from 'reselect';
import { selectors as cookSelectors } from 'ducks/cook';

export default createSelector(cookSelectors.getData, data => {
  return {
    startDate: data?.context?.fields?.startDate,
    endDate: data?.context?.fields?.endDate,
  };
});
